(function () {
  var heroEl = document.querySelector('[data-wped-hero]');
  var metaPageType = (window.meta && meta.page && meta.page.pageType)
    || (window.Shopify && Shopify.analytics && Shopify.analytics.meta && Shopify.analytics.meta.page && Shopify.analytics.meta.page.pageType)
    || '';
  var isProductSurface = !!(
    heroEl ||
    metaPageType === 'product'
  );
  if (!isProductSurface) {
    return;
  }
  var needsGalleryFix = heroEl && heroEl.querySelector('[data-wped-gallery-carousel]') &&
    typeof heroEl.__wpedGalleryGoTo !== 'function';
  if (needsGalleryFix && heroEl) {
    delete heroEl.dataset.wpedHeroInit;
    delete heroEl.dataset.wpedGalleryPilotInit;
    document.querySelectorAll('[data-wped-buy]').forEach(function (el) {
      delete el.dataset.wpedBuyInit;
    });
    window.__wpedEdBooted = false;
  }
  if (document.body) {
    document.body.classList.add('template-product', 'editorial-pilot');
  } else {
    document.addEventListener('DOMContentLoaded', function () {
      document.body.classList.add('template-product', 'editorial-pilot');
    });
  }
  document.documentElement.classList.add('editorial-pilot');

  function defaultMoneyFormat() {
    if (window.Wudy && window.Wudy.moneyFormat) return window.Wudy.moneyFormat;
    return '${{amount}}';
  }

  function formatMoney(cents, format) {
    if (window.Shopify && typeof Shopify.formatMoney === 'function') {
      return Shopify.formatMoney(cents, format || defaultMoneyFormat());
    }
    return '$' + (cents / 100).toFixed(2);
  }

  function isMobileGallery() {
    return window.matchMedia('(max-width: 749px)').matches;
  }

  function heroSrcsetForUrl(url) {
    if (!url || url.indexOf('cdn.shopify.com') === -1) return '';
    var base = url.split('?')[0];
    var widths = isMobileGallery() ? [480, 720, 960] : [720, 960, 1200];
    return widths
      .map(function (w) {
        return base + '?width=' + w + ' ' + w + 'w';
      })
      .join(', ');
  }

  function applyHeroImage(stageImg, url) {
    if (!stageImg || !url) return;
    stageImg.src = url;
    var srcset = heroSrcsetForUrl(url);
    if (srcset) {
      stageImg.srcset = srcset;
      stageImg.sizes = isMobileGallery()
        ? '(max-width: 749px) 92vw, 540px'
        : '(max-width: 989px) 50vw, 540px';
    } else {
      stageImg.removeAttribute('srcset');
      stageImg.removeAttribute('sizes');
    }
  }

  function switchHeroMedia(heroRoot, mediaId, mediaUrl, opts) {
    if (!heroRoot) return false;
    opts = opts || {};

    if (heroRoot.querySelector('[data-wped-gallery-carousel]') && typeof heroRoot.__wpedGalleryGoTo === 'function') {
      return heroRoot.__wpedGalleryGoTo(mediaId, mediaUrl, opts);
    }

    var stageImg = heroRoot.querySelector('[data-wped-main-image]');
    var thumbs = heroRoot.querySelectorAll('[data-wped-thumb]');
    var thumbItems = heroRoot.querySelectorAll('.wped-hero__thumb-item');
    var dots = heroRoot.querySelectorAll('[data-wped-dot]');
    var triggers = thumbs.length ? thumbs : dots;
    var index = -1;

    triggers.forEach(function (el, n) {
      var idMatch = mediaId && String(el.getAttribute('data-media-id')) === String(mediaId);
      var urlMatch = mediaUrl && el.getAttribute('data-media-url') === mediaUrl;
      if (idMatch || urlMatch) index = n;
    });

    if (index >= 0) {
      var url = triggers[index].getAttribute('data-media-url');
      if (stageImg && url) {
        applyHeroImage(stageImg, url);
      }
      thumbItems.forEach(function (el, n) {
        el.classList.toggle('is-active', n === index);
      });
      thumbs.forEach(function (el, n) {
        el.setAttribute('aria-selected', n === index ? 'true' : 'false');
      });
      dots.forEach(function (el, n) {
        el.classList.toggle('is-active', n === index);
      });
      heroRoot.__wpedHeroIndex = index;
      syncThumbScroll(heroRoot, mediaId, url);
      return true;
    }

    if (mediaUrl && stageImg) {
      applyHeroImage(stageImg, mediaUrl);
      syncThumbScroll(heroRoot, mediaId, mediaUrl);
      return true;
    }

    return false;
  }

  function scrollThumbIntoView(heroRoot, index) {
    var col = heroRoot.querySelector('.wped-hero__thumbs-col');
    var items = heroRoot.querySelectorAll('.wped-hero__thumb-item');
    if (!col || !items.length || index < 0 || index >= items.length) return;

    var item = items[index];
    var horizontal = col.scrollWidth > col.clientWidth + 4;

    if (horizontal) {
      var left = item.offsetLeft - (col.clientWidth - item.offsetWidth) / 2;
      col.scrollTo({ left: Math.max(0, left), behavior: 'smooth' });
      return;
    }

    var itemTop = item.offsetTop;
    var itemBottom = itemTop + item.offsetHeight;
    var viewTop = col.scrollTop;
    var viewBottom = viewTop + col.clientHeight;

    if (itemTop < viewTop) {
      col.scrollTop = itemTop;
    } else if (itemBottom > viewBottom) {
      col.scrollTop = itemBottom - col.clientHeight;
    }
  }

  function syncThumbScroll(heroRoot, mediaId, mediaUrl) {
    var triggers = heroRoot.querySelectorAll('[data-wped-thumb]');
    if (!triggers.length) return;
    triggers.forEach(function (el, n) {
      var idMatch = mediaId && String(el.getAttribute('data-media-id')) === String(mediaId);
      var urlMatch = mediaUrl && el.getAttribute('data-media-url') === mediaUrl;
      if (idMatch || urlMatch) scrollThumbIntoView(heroRoot, n);
    });
  }
  function updateHeroPrice(root, unitCents, compareCents, unitFormatted, compareFormatted) {
    var hero = root ? root.closest('[data-wped-hero]') : null;
    if (!hero) hero = document.querySelector('[data-wped-hero]');
    if (!hero) return;

    var moneyFormat = root && root.querySelector('[data-wped-price]')
      ? root.querySelector('[data-wped-price]').getAttribute('data-wped-money-format')
      : null;

    var current = hero.querySelector('[data-wped-hero-price-current]');
    var compare = hero.querySelector('[data-wped-hero-price-compare]');

    if (current && unitCents) {
      current.textContent = unitFormatted || formatMoney(parseInt(unitCents, 10), moneyFormat);
    }

    var saveEl = hero.querySelector('[data-wped-hero-price-save]');
    var saveNote = hero.querySelector('.wped-hero__price-note');
    var unit = parseInt(unitCents, 10);
    var compareVal = parseInt(compareCents, 10);

    if (compare && compareVal > unit) {
      compare.hidden = false;
      compare.textContent = compareFormatted || formatMoney(compareVal, moneyFormat);
      if (saveEl) {
        var saveCents = compareVal - unit;
        var savePct = Math.round((saveCents / compareVal) * 100);
        saveEl.textContent = 'Save ' + savePct + '%';
        saveEl.hidden = false;
        if (saveNote) {
          saveNote.textContent = 'You save ' + formatMoney(saveCents, moneyFormat) + ' on this set';
          saveNote.hidden = false;
        }
      }
    } else if (compare) {
      compare.hidden = true;
      if (saveEl) saveEl.hidden = true;
      if (saveNote) saveNote.hidden = true;
    }
  }

  function hideWpedAtcToast(toast) {
    if (!toast) return;
    toast.classList.remove('is-visible');
    toast.hidden = true;
  }

  function showWpedAtcToast(title, sub, isError) {
    var toast = document.querySelector('[data-wped-atc-toast]');
    if (!toast) return;
    var titleEl = toast.querySelector('[data-wped-toast-title]');
    var subEl = toast.querySelector('[data-wped-toast-sub]');
    var actions = toast.querySelector('[data-wped-toast-actions]');
    var keep = toast.querySelector('[data-wped-toast-keep]');
    if (titleEl) titleEl.textContent = title || 'Added to cart';
    if (subEl) subEl.textContent = sub || 'Choose what you’d like to do next.';
    if (actions) actions.hidden = !!isError;
    if (keep && keep.dataset.wpedToastInit !== 'true') {
      keep.dataset.wpedToastInit = 'true';
      keep.addEventListener('click', function () {
        clearTimeout(showWpedAtcToast._timer);
        hideWpedAtcToast(toast);
      });
    }
    toast.classList.toggle('wped-atc-toast--error', !!isError);
    toast.classList.toggle('wped-atc-toast--choice', !isError);
    toast.hidden = false;
    toast.classList.add('is-visible');
    clearTimeout(showWpedAtcToast._timer);
    showWpedAtcToast._timer = setTimeout(function () {
      hideWpedAtcToast(toast);
    }, isError ? 3200 : 8000);
  }
  window.showWpedAtcToast = showWpedAtcToast;

  function findWpedPurchaseAnchor() {
    var selectors = [
      '.wped-hero__purchase',
      '[data-wped-buy]',
      '.wlp-hero__buy',
      '#lp-buy',
      '.wudy-pdp-buy',
      '.wped-buy__submit',
      'product-form',
    ];
    for (var i = 0; i < selectors.length; i++) {
      var hit = document.querySelector(selectors[i]);
      if (hit) return hit;
    }
    return (
      document.querySelector('.wped-hero') ||
      document.querySelector('.wlp-hero') ||
      document.querySelector('.wudy-pdp-master--hero') ||
      null
    );
  }

  function findWpedVariantInput() {
    return (
      document.querySelector('[data-wped-variant-input]') ||
      document.querySelector('[data-wped-buy] input[name="id"]') ||
      document.querySelector('.wudy-pdp-buy input[name="id"]') ||
      document.querySelector('product-form input[name="id"]') ||
      document.querySelector('form[action*="/cart/add"] input[name="id"]')
    );
  }

  function findWpedPriceEl() {
    return (
      document.querySelector('[data-wped-price]') ||
      document.querySelector('.wlp-hero__price-current') ||
      document.querySelector('.wudy-pdp-buy__price')
    );
  }

  function initStickyAtc() {
    var stickies = document.querySelectorAll('[data-wped-sticky-atc]');
    for (var si = 1; si < stickies.length; si++) {
      var extraWrap = stickies[si].closest('.shopify-section');
      if (extraWrap) extraWrap.remove();
      else stickies[si].remove();
    }
    var sticky = document.querySelector('[data-wped-sticky-atc]');
    if (!sticky) return;
    if (sticky.dataset.wpedStickyInit === 'true') return;
    sticky.dataset.wpedStickyInit = 'true';

    var purchaseAnchor = findWpedPurchaseAnchor();
    var stickySubmit = sticky.querySelector('[data-wped-sticky-submit]');
    var stickyPrice = sticky.querySelector('[data-wped-sticky-price]');
    var stickyCompare = sticky.querySelector('[data-wped-sticky-compare]');
    var stickyBtnText = sticky.querySelector('[data-wped-sticky-btn-text]');
    var priceEl = findWpedPriceEl();
    var variantInput = findWpedVariantInput();
    var fallbackVariant = sticky.querySelector('[data-wped-sticky-fallback-variant]');
    var qtyInput =
      document.querySelector('[data-wped-buy] input[name="quantity"]') ||
      document.querySelector('.wudy-pdp-buy input[name="quantity"]');
    var moneyFormat = priceEl ? priceEl.getAttribute('data-wped-money-format') : null;
    var productTitle =
      sticky.getAttribute('data-wped-sticky-title') ||
      (document.querySelector('.wped-hero__title') || {}).textContent ||
      'Your item';
    var purchaseVisible = true;
    var minScroll = 96;

    function setStickyVisible(show) {
      var on = !!show;
      sticky.hidden = !on;
      sticky.classList.toggle('is-visible', on);
      document.body.classList.toggle('wped-sticky-dock-active', on);
    }

    function syncStickyPrice() {
      if (!priceEl || !stickyPrice) return;
      var cents = priceEl.getAttribute('data-wped-unit-cents');
      if (cents) stickyPrice.textContent = formatMoney(parseInt(cents, 10), moneyFormat);
      var selectedSwatch = document.querySelector('[data-wped-swatch].is-selected');
      if (stickyCompare) {
        var compareFormatted = selectedSwatch
          ? selectedSwatch.getAttribute('data-compare-formatted')
          : '';
        if (compareFormatted) {
          stickyCompare.textContent = compareFormatted;
          stickyCompare.hidden = false;
        } else {
          stickyCompare.hidden = true;
        }
      }
    }

    function updateStickyVisibility() {
      var scrolledEnough = window.scrollY >= minScroll;
      setStickyVisible(scrolledEnough && !purchaseVisible);
    }

    if (purchaseAnchor) {
      var observer = new IntersectionObserver(
        function (entries) {
          if (!entries || !entries.length) return;
          purchaseVisible = entries[0].isIntersecting;
          updateStickyVisibility();
        },
        { threshold: 0, rootMargin: '-72px 0px 0px 0px' }
      );
      observer.observe(purchaseAnchor);
    } else {
      purchaseVisible = false;
    }
    window.addEventListener('scroll', updateStickyVisibility, { passive: true });

    function setStickyLoading(loading) {
      if (!stickySubmit) return;
      stickySubmit.classList.toggle('is-loading', !!loading);
      stickySubmit.disabled = !!loading || stickySubmit.getAttribute('aria-disabled') === 'true';
    }

    function addToCartFromSticky() {
      if (!stickySubmit || stickySubmit.disabled) return;
      var variantId = variantInput ? variantInput.value : null;
      if (!variantId && fallbackVariant) variantId = fallbackVariant.value;
      if (!variantId) {
        showWpedAtcToast('Choose an option', 'Select a variant above first.', true);
        return;
      }
      var qty = qtyInput ? Math.max(1, parseInt(qtyInput.value || '1', 10)) : 1;
      setStickyLoading(true);
      var addPromise = window.WudyAtc
        ? window.WudyAtc.addVariant(variantId, qty)
        : fetch((window.routes && window.routes.cart_add_url ? window.routes.cart_add_url : '/cart/add') + '.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ items: [{ id: variantId, quantity: qty }] }),
          }).then(function (response) {
            return response.json().then(function (data) {
              if (!response.ok) throw data;
              return data;
            });
          });
      addPromise
        .then(function () {
          if (window.WudyAtc && window.WudyAtc.closeCartDrawer) window.WudyAtc.closeCartDrawer();
          showWpedAtcToast('Added to cart', window.WudyAtc && window.WudyAtc.redirectToastSub ? window.WudyAtc.redirectToastSub() : 'Taking you to checkout…');
        })
        .catch(function (err) {
          var msg = (err && (err.description || err.message)) || 'Could not add to cart. Try again.';
          showWpedAtcToast('Something went wrong', msg, true);
        })
        .finally(function () {
          setStickyLoading(false);
        });
    }

    if (stickySubmit) {
      stickySubmit.addEventListener('click', addToCartFromSticky);
    }

    document.addEventListener('wped:price-updated', syncStickyPrice);
    document.addEventListener('wped:variant-change', function (event) {
      syncStickyPrice();
      if (!event.detail || !event.detail.variantId) return;
      if (variantInput) variantInput.value = event.detail.variantId;
    });

    syncStickyPrice();
    updateStickyVisibility();
  }


  function initGalleryPilot(root) {
    if (!root || root.dataset.wpedGalleryPilotInit === 'true') return;
    root.dataset.wpedGalleryPilotInit = 'true';

    var viewport = root.querySelector('.wped-hero__carousel-viewport');
    var track = root.querySelector('[data-wped-gallery-carousel] .wped-hero__carousel-track');
    var slides = root.querySelectorAll('[data-wped-carousel-slide]');
    var filmstripItems = root.querySelectorAll('.wped-hero__filmstrip-item');
    var filmstripBtns = root.querySelectorAll('[data-wped-filmstrip-thumb]');
    var prev = root.querySelector('[data-wped-prev]');
    var next = root.querySelector('[data-wped-next]');
    if (!track || !slides.length) return;

    var index = 0;
    var ticking = false;

    function slideWidth() {
      return track.clientWidth || (viewport && viewport.clientWidth) || 0;
    }

    function slideOffset(n) {
      return slideWidth() * n;
    }

    function setActive(i, opts) {
      opts = opts || {};
      index = (i + slides.length) % slides.length;
      root.__wpedHeroIndex = index;
      slides.forEach(function (slide, n) {
        slide.classList.toggle('is-active', n === index);
      });
      filmstripItems.forEach(function (item, n) {
        item.classList.toggle('is-active', n === index);
      });
      filmstripBtns.forEach(function (btn, n) {
        btn.setAttribute('aria-selected', n === index ? 'true' : 'false');
      });
      if (opts.scrollFilmstrip !== false && filmstripItems[index]) {
        var item = filmstripItems[index];
        var list = item.parentElement;
        if (list) {
          var left = item.offsetLeft - (list.clientWidth - item.offsetWidth) / 2;
          list.scrollTo({ left: Math.max(0, left), behavior: opts.smooth === false ? 'auto' : 'smooth' });
        }
      }
    }

    function nearestIndex() {
      var w = slideWidth();
      if (!w) return index;
      return Math.max(0, Math.min(slides.length - 1, Math.round(track.scrollLeft / w)));
    }

    function goTo(i, smooth) {
      var targetIndex = (i + slides.length) % slides.length;
      track.scrollTo({ left: slideOffset(targetIndex), behavior: smooth === false ? 'auto' : 'smooth' });
      setActive(targetIndex, { scrollFilmstrip: true, smooth: smooth !== false });
    }

    function syncToIndex(i, smooth) {
      var targetIndex = Math.max(0, Math.min(slides.length - 1, i));
      track.scrollTo({ left: slideOffset(targetIndex), behavior: smooth === false ? 'auto' : 'smooth' });
      setActive(targetIndex, { scrollFilmstrip: false, smooth: false });
    }

    function onScroll() {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(function () {
        ticking = false;
        var nextIndex = nearestIndex();
        if (nextIndex !== index) setActive(nextIndex, { scrollFilmstrip: true, smooth: false });
      });
    }

    track.addEventListener('scroll', onScroll, { passive: true });

    filmstripBtns.forEach(function (btn, n) {
      btn.addEventListener('click', function () { goTo(n, true); markInteracted(); });
    });

    if (prev) prev.addEventListener('click', function () { goTo(index - 1, true); markInteracted(); });
    if (next) next.addEventListener('click', function () { goTo(index + 1, true); markInteracted(); });

    var heroSection = root.closest('.wped-hero--gallery-pilot');
    function markInteracted() {
      if (heroSection) heroSection.classList.add('is-carousel-interacted');
    }

    slides.forEach(function (slide, n) {
      if (slide.classList.contains('is-active')) index = n;
    });

    var userBrowsing = false;
    var scrollEndTimer = null;
    var reflowTimer = null;

    function markUserBrowsing() {
      userBrowsing = true;
      markInteracted();
    }

    function slideIndexForMedia(mediaId) {
      if (!mediaId) return -1;
      var found = -1;
      slides.forEach(function (slide, n) {
        if (String(slide.getAttribute('data-media-id')) === String(mediaId)) found = n;
      });
      return found;
    }

    root.__wpedGalleryGoTo = function (mediaId, mediaUrl, opts) {
      opts = opts || {};
      if (opts.fromVariant !== true) return false;
      var found = slideIndexForMedia(mediaId);
      if (found < 0) return false;
      if (opts.smooth === false) syncToIndex(found, false);
      else goTo(found, true);
      return true;
    };

    function reflow() {
      if (scrollEndTimer) return;
      var w = slideWidth();
      if (!w) return;
      var current = nearestIndex();
      index = current;
      setActive(current, { scrollFilmstrip: false, smooth: false });
      var target = slideOffset(current);
      if (Math.abs(track.scrollLeft - target) > 2) {
        track.scrollLeft = target;
      }
    }

    function scheduleReflow() {
      if (scrollEndTimer) return;
      clearTimeout(reflowTimer);
      reflowTimer = setTimeout(reflow, 80);
    }

    if (typeof ResizeObserver === 'function' && viewport) {
      var ro = new ResizeObserver(function () { scheduleReflow(); });
      ro.observe(viewport);
    } else {
      window.addEventListener('resize', scheduleReflow);
    }

    track.addEventListener('scroll', function () {
      markUserBrowsing();
      clearTimeout(scrollEndTimer);
      scrollEndTimer = setTimeout(function () {
        scrollEndTimer = null;
      }, 120);
    }, { passive: true });

    syncToIndex(index, false);

    // Fresh open: keep featured/carousel start. Only jump when URL deep-links a variant.
    if (/[?&]variant=/.test(window.location.search || '')) {
      var selectedSwatch = document.querySelector('[data-wped-swatch].is-selected');
      if (selectedSwatch) {
        var initMediaId = selectedSwatch.getAttribute('data-media-id');
        if (initMediaId) {
          var initIdx = slideIndexForMedia(initMediaId);
          if (initIdx >= 0) syncToIndex(initIdx, false);
        }
      }
    }

    if (root.querySelector('[data-wped-gallery-zoom]')) initGalleryZoom(root);
  }

  function initHero(root) {
    if (!root || root.dataset.wpedHeroInit === 'true') return;
    root.dataset.wpedHeroInit = 'true';

    if (root.querySelector('[data-wped-gallery-carousel]')) {
      initGalleryPilot(root);
      return;
    }

    var thumbCol = root.querySelector('.wped-hero__thumbs-col');
    if (thumbCol && !thumbCol.dataset.wpedWheelBound) {
      thumbCol.dataset.wpedWheelBound = 'true';
      thumbCol.addEventListener('wheel', function (event) {
        var maxScroll = thumbCol.scrollHeight - thumbCol.clientHeight;
        if (maxScroll <= 0) return;
        var goingDown = event.deltaY > 0;
        var atTop = thumbCol.scrollTop <= 0;
        var atBottom = thumbCol.scrollTop >= maxScroll - 1;
        if ((goingDown && !atBottom) || (!goingDown && !atTop)) {
          event.stopPropagation();
        }
      }, { passive: true });
    }

    var stageImg = root.querySelector('[data-wped-main-image]');
    var thumbs = root.querySelectorAll('[data-wped-thumb]');
    var thumbItems = root.querySelectorAll('.wped-hero__thumb-item');
    var dots = root.querySelectorAll('[data-wped-dot]');
    var prev = root.querySelector('[data-wped-prev]');
    var next = root.querySelector('[data-wped-next]');
    var stage = root.querySelector('.wped-hero__stage');
    var triggers = thumbs.length ? thumbs : dots;
    var index = 0;

    function setActive(i) {
      if (!triggers.length) return;
      index = (i + triggers.length) % triggers.length;
      var mediaId = triggers[index].getAttribute('data-media-id');
      var url = triggers[index].getAttribute('data-media-url');
      switchHeroMedia(root, mediaId, url);
      root.__wpedHeroIndex = index;
      scrollThumbIntoView(root, index);
    }

    thumbs.forEach(function (el, n) {
      el.addEventListener('click', function () { setActive(n); });
    });

    dots.forEach(function (el, n) {
      el.addEventListener('click', function () { setActive(n); });
    });

    if (prev) prev.addEventListener('click', function () { setActive(index - 1); });
    if (next) next.addEventListener('click', function () { setActive(index + 1); });

    if (stage && triggers.length > 1) {
      var startX = 0;
      var startY = 0;
      var startTs = 0;
      var tracking = false;
      var SWIPE_MIN_X = 36;
      var SWIPE_MAX_MS = 750;
      var lastSwipeAt = 0;

      function maybeSwipe(dx, dy, dt) {
        if (Math.abs(dx) < SWIPE_MIN_X) return;
        if (Math.abs(dx) < Math.abs(dy) * 1.2) return;
        if (dt > SWIPE_MAX_MS) return;
        var now = Date.now();
        if (now - lastSwipeAt < 220) return;
        lastSwipeAt = now;
        if (dx < 0) setActive(index + 1);
        else setActive(index - 1);
      }

      stage.addEventListener('touchstart', function (event) {
        if (!event.touches || event.touches.length !== 1) return;
        var touch = event.touches[0];
        startX = touch.clientX;
        startY = touch.clientY;
        startTs = Date.now();
        tracking = true;
      }, { passive: true });

      stage.addEventListener('touchend', function (event) {
        if (!tracking || !event.changedTouches || !event.changedTouches.length) return;
        tracking = false;
        var touch = event.changedTouches[0];
        var dx = touch.clientX - startX;
        var dy = touch.clientY - startY;
        var dt = Date.now() - startTs;
        maybeSwipe(dx, dy, dt);
      }, { passive: true });

      stage.addEventListener('pointerdown', function (event) {
        if (event.isPrimary === false) return;
        if (event.pointerType === 'mouse' && event.button !== 0) return;
        startX = event.clientX;
        startY = event.clientY;
        startTs = Date.now();
        tracking = true;
      });

      stage.addEventListener('pointerup', function (event) {
        if (!tracking || event.isPrimary === false) return;
        tracking = false;
        var dx = event.clientX - startX;
        var dy = event.clientY - startY;
        var dt = Date.now() - startTs;
        maybeSwipe(dx, dy, dt);
      });
    }

    if (root.querySelector('[data-wped-gallery-zoom]')) {
      initGalleryZoom(root);
    }
  }

  function initGalleryZoom(root) {
    if (!root || root.dataset.wpedZoomInit === 'true') return;
    root.dataset.wpedZoomInit = 'true';

    var stage = root.querySelector('[data-wped-gallery-zoom]');
    if (!stage) return;

    function activeZoomImage() {
      var activeSlide = stage.querySelector('[data-wped-carousel-slide].is-active');
      if (activeSlide) {
        return activeSlide.querySelector('.wped-hero__carousel-image');
      }
      return stage.querySelector('[data-wped-main-image]');
    }

    var stageImg = activeZoomImage();
    if (!stageImg) return;

    var lightbox = document.createElement('div');
    lightbox.className = 'wped-gallery-lightbox';
    lightbox.hidden = true;
    lightbox.innerHTML =
      '<button type="button" class="wped-gallery-lightbox__close" data-wped-zoom-close aria-label="Close image">' +
      '<svg width="18" height="18" viewBox="0 0 18 18" fill="none" aria-hidden="true"><path d="M4 4l10 10M14 4L4 14" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/></svg>' +
      '</button>' +
      '<img class="wped-gallery-lightbox__img" data-wped-zoom-img alt="" />';
    document.body.appendChild(lightbox);

    var zoomImg = lightbox.querySelector('[data-wped-zoom-img]');
    var closeBtn = lightbox.querySelector('[data-wped-zoom-close]');

    function openZoom() {
      var url = stageImg.currentSrc || stageImg.src;
      if (!url) return;
      var zoomUrl = url.indexOf('cdn.shopify.com') !== -1 ? url.split('?')[0] + '?width=2400' : url;
      zoomImg.src = zoomUrl;
      zoomImg.alt = stageImg.alt || '';
      lightbox.hidden = false;
      document.body.classList.add('wped-gallery-lightbox-open');
      closeBtn.focus();
    }

    function closeZoom() {
      lightbox.hidden = true;
      document.body.classList.remove('wped-gallery-lightbox-open');
      zoomImg.removeAttribute('src');
    }

    function bindZoomTarget(img) {
      if (!img || img.dataset.wpedZoomBound === 'true') return;
      img.dataset.wpedZoomBound = 'true';
      img.style.cursor = 'zoom-in';
      img.addEventListener('click', function (event) {
        event.stopPropagation();
        stageImg = img;
        openZoom();
      });
    }

    stage.querySelectorAll('.wped-hero__carousel-image, [data-wped-main-image]').forEach(bindZoomTarget);

    var observer = new MutationObserver(function () {
      stage.querySelectorAll('.wped-hero__carousel-image, [data-wped-main-image]').forEach(bindZoomTarget);
    });
    observer.observe(stage, { subtree: true, attributes: true, attributeFilter: ['class'] });

    closeBtn.addEventListener('click', closeZoom);
    lightbox.addEventListener('click', function (event) {
      if (event.target === lightbox) closeZoom();
    });

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && !lightbox.hidden) closeZoom();
    });
  }

  function initBuy(root) {
    if (!root || root.dataset.wpedBuyInit === 'true') return;
    root.dataset.wpedBuyInit = 'true';

    var qtyWrap = root.querySelector('[data-wped-qty]');
    var priceEl = root.querySelector('[data-wped-price]');
    var moneyFormat = priceEl ? priceEl.getAttribute('data-wped-money-format') : null;

    function getUnitCents() {
      if (!priceEl) return 0;
      return parseInt(priceEl.getAttribute('data-wped-unit-cents') || '0', 10);
    }

    function updatePriceDisplay(input) {
      if (!priceEl || !input) return;
      var qty = Math.max(1, parseInt(input.value || '1', 10));
      input.value = qty;
      priceEl.textContent = formatMoney(getUnitCents() * qty, moneyFormat);
      document.dispatchEvent(new CustomEvent('wped:price-updated'));
    }

    if (qtyWrap) {
      var input = qtyWrap.querySelector('input[name="quantity"]');
      var minus = qtyWrap.querySelector('[data-wped-qty-minus]');
      var plus = qtyWrap.querySelector('[data-wped-qty-plus]');

      if (minus && input) {
        minus.addEventListener('click', function () {
          input.value = Math.max(1, parseInt(input.value || '1', 10) - 1);
          updatePriceDisplay(input);
        });
      }

      if (plus && input) {
        plus.addEventListener('click', function () {
          input.value = Math.max(1, parseInt(input.value || '1', 10) + 1);
          updatePriceDisplay(input);
        });
      }

      if (input) {
        input.addEventListener('change', function () {
          updatePriceDisplay(input);
        });
      }
    }

    function syncSwatchSelection(btn) {
      var variantId = btn.getAttribute('data-variant-id');
      var value = btn.getAttribute('data-value');
      document.querySelectorAll('[data-wped-swatch]').forEach(function (el) {
        var match = (variantId && el.getAttribute('data-variant-id') === variantId) ||
          (value && el.getAttribute('data-value') === value);
        el.classList.toggle('is-selected', !!match);
      });
      document.querySelectorAll('[data-wped-option-label]').forEach(function (label) {
        var option = label.closest('[data-wped-option]');
        if (!option) return;
        var matchBtn = option.querySelector('[data-wped-swatch][data-variant-id="' + variantId + '"]') ||
          option.querySelector('[data-wped-swatch][data-value="' + value + '"]');
        if (matchBtn) {
          label.textContent = matchBtn.getAttribute('data-display-value') || matchBtn.getAttribute('data-value');
        }
      });
    }

    function applyVariantSelection(btn) {
      syncSwatchSelection(btn);
      var hidden = document.querySelector('[data-wped-variant-input]');
      var variantId = btn.getAttribute('data-variant-id');
      var unitCents = btn.getAttribute('data-price-cents');
      var unitFormatted = btn.getAttribute('data-price-formatted');
      var compareFormatted = btn.getAttribute('data-compare-formatted');
      if (hidden && variantId) hidden.value = variantId;
      if (variantId && window.history && window.history.replaceState) {
        var nextUrl = new URL(window.location.href);
        nextUrl.searchParams.set('variant', variantId);
        window.history.replaceState({ variantId: variantId }, '', nextUrl.toString());
      }
      if (priceEl && unitCents) {
        priceEl.setAttribute('data-wped-unit-cents', unitCents);
        if (unitFormatted) priceEl.setAttribute('data-wped-unit-formatted', unitFormatted);
        var qtyInput = root.querySelector('input[name="quantity"]');
        updatePriceDisplay(qtyInput || { value: '1' });
        updateHeroPrice(
          root,
          unitCents,
          btn.getAttribute('data-compare-cents'),
          unitFormatted,
          compareFormatted
        );
        document.dispatchEvent(new CustomEvent('wped:price-updated'));
      }

      var hero = root.closest('[data-wped-hero]') || document.querySelector('[data-wped-hero]');
      var mediaId = btn.getAttribute('data-media-id');
      var mediaUrl = btn.getAttribute('data-media-url');
      if (hero && (mediaId || mediaUrl)) {
        switchHeroMedia(hero, mediaId, mediaUrl, { fromVariant: true, smooth: true });
      }

      document.dispatchEvent(
        new CustomEvent('wped:variant-change', {
          detail: { variantId: variantId, root: root },
        })
      );
    }

    root.querySelectorAll('[data-wped-swatch]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        applyVariantSelection(btn);
      });
    });

    // Fresh open: do not override hero with the last/selected variant image.
    // Deep link (?variant=): sync hero to that variant's media.
    if (/[?&]variant=/.test(window.location.search || '')) {
      var initialSwatch = root.querySelector('[data-wped-swatch].is-selected');
      if (initialSwatch) {
        var heroRoot = root.closest('[data-wped-hero]') || document.querySelector('[data-wped-hero]');
        var hasCarousel = heroRoot && heroRoot.querySelector('[data-wped-gallery-carousel]');
        if (!hasCarousel) {
          var mediaId = initialSwatch.getAttribute('data-media-id');
          var mediaUrl = initialSwatch.getAttribute('data-media-url');
          if (heroRoot && (mediaId || mediaUrl)) {
            switchHeroMedia(heroRoot, mediaId, mediaUrl);
          }
        }
      }
    }
  }

  function initTabs(root) {
    if (!root || root.dataset.wpedTabsInit === 'true') return;
    root.dataset.wpedTabsInit = 'true';

    var tabs = root.querySelectorAll('[data-wped-tab]');
    var panels = root.querySelectorAll('[data-wped-panel]');
    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        var id = tab.getAttribute('data-wped-tab');
        tabs.forEach(function (el) { el.classList.toggle('is-active', el === tab); });
        panels.forEach(function (panel) {
          panel.hidden = panel.getAttribute('data-wped-panel') !== id;
        });
      });
    });
  }

  function initAccordion(root) {
    if (!root || root.dataset.wpedAccInit === 'true') return;
    root.dataset.wpedAccInit = 'true';

    root.querySelectorAll('[data-wped-acc-trigger]').forEach(function (trigger) {
      trigger.addEventListener('click', function () {
        var panelId = trigger.getAttribute('aria-controls');
        var panel = panelId ? document.getElementById(panelId) : null;
        if (!panel && panelId) {
          panel = root.querySelector('[data-wped-acc-panel="' + panelId + '"]');
        }
        var open = trigger.getAttribute('aria-expanded') === 'true';
        trigger.setAttribute('aria-expanded', open ? 'false' : 'true');
        if (panel) panel.hidden = open;
      });
    });
  }

  function boot(scope) {
    scope = scope || document;
    scope.querySelectorAll('[data-wped-hero]').forEach(initHero);
    scope.querySelectorAll('[data-wped-buy]').forEach(initBuy);
    scope.querySelectorAll('[data-wped-overview]').forEach(function (root) {
      initTabs(root);
      initAccordion(root);
    });
    scope.querySelectorAll('[data-wped-faq]').forEach(initAccordion);
    initStickyAtc();
    if (window.WudyWishlist && typeof window.WudyWishlist.bind === 'function') {
      window.WudyWishlist.bind(scope);
    }
  }

  if (window.__wpedEdBooted) return;
  window.__wpedEdBooted = true;

  document.addEventListener('DOMContentLoaded', function () { boot(); });
  document.addEventListener('shopify:section:load', function (event) { boot(event.target); });
})();
